// extracted by mini-css-extract-plugin
export var currencyInput = "_nz-1";
export var currencySymbol = "_nz-0";